import { ReqIdHistoryUseCase } from "@domains/features/EDIS/useCases/reqIdHistory";
import { HoldingUseCase } from "@domains/features/EDIS/useCases/holdingUseCase";
import { HistoryUseCase } from "@domains/features/EDIS/useCases/historyUseCase";
import { StatusUseCase } from "@domains/features/EDIS/useCases/status";
export default (function (repositories) {
    return {
        edis: {
            holdingDetails: new HoldingUseCase(repositories.edis),
            historyDetails: new HistoryUseCase(repositories.edis),
            reqIdHistory: new ReqIdHistoryUseCase(repositories.edis),
            statusDetails: new StatusUseCase(repositories.edis),
        },
    };
});
